<template>
    <BasePanel v-if="event.ticketPartnerUrlGuest">
        <template #title>
            Koop een regulier ticket
        </template>

        <template #default>
            <BaseButton
                element="a"
                :href="event.ticketPartnerUrlGuest"
                class="button--secondary button--stretch"
            >
                Koop ticket voor €{{ ticketPricing.parsedPriceRegular }}
            </BaseButton>
        </template>
    </BasePanel>
</template>

<script setup lang="ts">
defineProps<{
    event: EventDate;
}>();

const eventsStore = useEventsStore();

const { ticketPricing } = storeToRefs(eventsStore);
</script>
